define('views/pages/trade/offer/index',['require','jquery','underscore','views/base/view','views/pages/trade/offer/navbar','views/pages/trade/offer/table','views/pages/trade/offer/basket-sum','views/pages/trade/offer/basket','views/filter/index','text!templates/pages/trade/offer/index.ejs'],function(require) {
    'use strict';

    var $ = require('jquery'),
        _ = require('underscore'),
        View = require('views/base/view'),
        TradeOfferNavbarView = require('views/pages/trade/offer/navbar'),
        TradeOfferTableView = require('views/pages/trade/offer/table'),
        TradeOfferBasketSumView = require('views/pages/trade/offer/basket-sum'),
        TradeOfferBasketView = require('views/pages/trade/offer/basket'),
        // TradeOfferFilterView = require('views/pages/trade/offer/filter'),
        FilterView = require('views/filter/index'),
        template = require('text!templates/pages/trade/offer/index.ejs');

    /*
        TRADE OFFER PAGE
    */

    var TradeOfferView = View.extend({
        autoRender: true,
        template: template,
        className: 'tab-pane',
        id: 'trade-offer-tab',
        region: 'trade-offer-tab',
        regions: {
            'trade-offer-navbar':     '#trade-offer-navbar-container',
            'trade-offer-table':      '#trade-offer-table-container',
            'trade-offer-basket-sum': '#trade-offer-basket-container',
            'trade-offer-basket':     '#trade-offer-basket-container',
            'trade-offer-filter':     '#trade-offer-filter-container'
        },
        listen: {
            'resize model': 'onResize'
        },
        initialize: function() {
            View.prototype.initialize.apply(this, arguments);

            this.model.filter.on('filterChanged', _.bind(this.onResizeDelayed, this));
        },
        onResizeDelayed: function() {
            setTimeout(_.bind(this.onResize, this), 10);
        },
        render: function() {
            View.prototype.render.apply(this, arguments);

            this.$el[(this.model.get('page') === 'offer') ? 'addClass' : 'removeClass']('active');


            this.subview('navbar', new TradeOfferNavbarView({ model: this.model }));
            this.subview('filter', new FilterView({ model: this.model.filter, region: 'trade-offer-filter' }));
            this.subview('table', new TradeOfferTableView({ collection: this.model.items, model: this.model }));
            this.subview('basket-sum', new TradeOfferBasketSumView({ model: this.model }));
            this.subview('basket', new TradeOfferBasketView({ collection: this.model.basket, model: this.model }));
        },
        onResize: function() {

            if (this.model.get('page') !== 'offer') {
                return;
            }

            var h;

            if (this.model.get('offerPage') === 'filter') {
                h = $('body')[0].scrollHeight;
            } else {
                h = $('body').height();
            }

            var $b = this.$('#trade-offer-table-container tbody');
            $b.css('height', h - $b.offset().top - 8);

            $b = this.$('#trade-basket-table tbody');
            $b.css('height', h - $b.offset().top - 8);

            // console.log('RESIZE');
        },
    });

    return TradeOfferView;
});

